import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import type { LayoutItem, WidgetConfig } from '@monitoring-panel/types';
import { api } from '@/services/api';

export function useDashboardConfig(executionId: string) {
  return useQuery({
    queryKey: ['dashboard-config', executionId],
    queryFn: () => api.dashboards.get(executionId),
    enabled: !!executionId,
    staleTime: 60000, // 1 minute
  });
}

export function useSaveDashboardConfig(executionId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { layout: LayoutItem[]; widgets: WidgetConfig[] }) =>
      api.dashboards.save(executionId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['dashboard-config', executionId] });
      toast.success('Dashboard saved');
    },
    onError: (error) => {
      toast.error(`Failed to save dashboard: ${error.message}`);
    },
  });
}

export function useDeleteDashboardConfig(executionId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.dashboards.delete(executionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['dashboard-config', executionId] });
      toast.success('Dashboard reset');
    },
    onError: (error) => {
      toast.error(`Failed to reset dashboard: ${error.message}`);
    },
  });
}
